import React from 'react';
import '../../App.css';
import '../Kontakt.css';

function Kontakt() {
  return (
    <div className="subpage-container">
      <h1>KONTAKT</h1>

      <div className="contact-card">
        <p className="contact-info-text">
          <i className="fas fa-phone-alt"></i> Tel.č: 
          <a className="contact-link" href="tel:0911151528"> 0911 151 528</a>
        </p>
        
        <p className="contact-info-text">
          <i className="fas fa-envelope"></i> Email: 
          <a className="contact-link" href="mailto:finis.nitra@gmail.com"> finis.nitra@gmail.com</a>
        </p>

        <p className="contact-info-text">
          <i className="fas fa-map-marker-alt"></i> Adresa: Nábrežie Mládeže 2B, Nitra
        </p>

        <iframe 
          id="map" 
          title="Finis Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2650.323602410884!2d18.0934!3d48.3108!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476b3f17387f9e85%3A0x6a05370f1a9a8342!2zTsOhYnJle8mพZSBNbMOhZGXFvmUgMkIsIDk0OSAwMSBOaXRyYQ!5e0!3m2!1ssk!2ssk!4v1650000000000!5m2!1ssk!2ssk"   
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
    </div>
  );
}

export default Kontakt;